import { render, staticRenderFns } from "./index.vue?vue&type=template&id=07a531bf&lang=pug"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07a531bf')) {
      api.createRecord('07a531bf', component.options)
    } else {
      api.reload('07a531bf', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=07a531bf&lang=pug", function () {
      api.rerender('07a531bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/vip/contracts/permanentlyContractInfo/permanentlyPayWay/unpaidSetting/toPaid/index.vue"
export default component.exports